import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // initialize i18n before rendering
import { applyDomSafeguards } from "@/lib/domSafeguards";
import App from "@/App";

// Defensive: patch Node.removeChild / insertBefore BEFORE React mounts so any
// third-party DOM mutator (Google Translate, password managers, etc.) cannot
// crash the app with a "Failed to execute 'removeChild' on 'Node'" exception.
applyDomSafeguards();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
